module.exports = __webpack_public_path__ + "static/media/epc.494d55c6.jpeg";